import React, { useEffect, useState } from "react";

// import KPIIndicatorModal from "./KPIIndicatorModal";
import { Modal } from "@mui/material";
import { useForm } from "react-hook-form";

import {
  getAllTrainingMasterList,
  getAllTrainingName,
  getAssessmentQuestionsList,
  getDeptDropdown,
  getTrainingMasterInfo,
} from "../../services/Training/TrainingMasterServices";
// import { baseUrl } from "../../../../http-common";
import Card from "./Card";
import HandHygienePreAssessmentModal from "./CommonAssessmentTestModal";
// import HandHygienePostAssessmentModal from "./HandHygienePostAssessmentModal";
import TrainingMasterModal from "./TrainingMasterModal";
import CommonHeading from "../../../../../common/components/Custom Hooks/CommonHeading";
import SearchDropdown from "../../../../../common/components/FormFields/searchDropdown";
import DropdownField from "../../../../../common/components/FormFields/DropdownField";
import CommonButton from "../../../../../common/components/Buttons/CommonButton";
import LoadingSpinner from "../../../../../common/components/loadingspinner/loadingSpinner";
import CommonBackDrop from "../../../../../common/components/CommonBackDrop/CommonBackDrop";
import { CloseModalIcon } from "../../../../../common/components/assets/commonassets/CommonAssets";
import { errorAlert } from "../../../../../common/components/Toasts/CustomToasts";
import { UseCheckConsecutiveCharacters } from "../../../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";
import { baseUrlTraining } from "../../../../../http-common";
import { getTrainingDocuments, getTrainingVideos } from "../../../../../course/services/TrainingServices";

const userActions = [
  {
    id: 0,
    permission: "Edit",
    isAction: true,
  },
  {
    id: 1,
    permission: "Delete",
    isAction: true,
  },
  {
    id: 2,
    permission: "Create",
    isAction: false,
  },
];

const TrainingsMaster = () => {
  const getUserInfo = JSON.parse(localStorage?.getItem("loggedUser"));

  const [coursesData, setCoursesData] = useState([]);
  const { control, watch } = useForm();
  let watchDepartment = watch("Department");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [spinner, showSpinner] = React.useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [searchString, setSearchString] = useState(null);
  const [openBackDrop, setOpenBackdrop] = useState(false);
  const [trainingNameOptions, setTrainingNameOptions] = useState([]);
  const [count, setCount] = useState(0);
  const [filePreview, setFilePreview] = useState(null);
  const [openPreAsstModal, setOpenPreAsstModal] = useState(false);
  const [openPostAsstModal, setOpenPostAsstModal] = useState(false);
  const [trainingModalOpen, setTrainingModalOpen] = useState(false);
  const [selectedRowDetail, setSelectedRowDetail] = useState(null);
  const [testData, setTestData] = useState({
    preAssessment: null,
    postAssessment: null,
  });
  const [departmentDropdown, setDepartmentDropdown] = useState([]);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [assessmentQuestionsData, setAssessmentQuestionsData] = useState([]);
  const [listingObject, setListingObject] = useState({
    searchString: "",
    page: page,
    size: null,
    searchId: null,
    menuId: null,
    departmentId: watchDepartment ? watchDepartment?.id : null,
  });
  const [selectedDataForAssessment, setSelectedDataForAsessment] =
    useState(null);
  let getTrainingDoc = async (doc, fileObj, onSuccess) => {
    setOpenBackdrop(true)
    try {
      console.log(doc,"fileObj")

      console.log(fileObj,"fileObj")
      const isVideo = fileObj?.type?.startsWith("video/");

      const response = isVideo
        ? await getTrainingVideos(doc)
        : await getTrainingDocuments(doc);
      const blob = response.data;
                setOpenBackdrop(false)

      // const contentType = response.headers["content-type"];
      if (!blob || blob.size === 0) {
        // errorAlert("File not found or empty");
        onSuccess?.(null);
        return;
      }

      const url = URL.createObjectURL(blob);
      if (fileObj?.type?.startsWith("video/")) {
        onSuccess?.(url);
        return;
      }
      if (fileObj?.type?.startsWith("image/")) {
        setImageUrl(url);
        console.log(imageUrl,"imageUrl")
        setFilePreview(fileObj);
        return;
      }
      if (fileObj?.type == "application/pdf") {
        const pdfBlob = new Blob([blob], { type: "application/pdf" });
        const pdfurl = URL.createObjectURL(pdfBlob);
        setPdfUrl(pdfurl);
        setFilePreview(fileObj);
        return;
      }

    } catch (error) {
      onSuccess?.(null);
      errorAlert(error?.message);
                setOpenBackdrop(false)

    }
  };
  // const renderFilePreview = () => {
  //   if (!filePreview) return null;
  //   if (filePreview.type?.startsWith("image/")) {
  //     return (
  //       <div className="rounded-md p-3">
  //         <div className="flex justify-between">
  //           <p className={`text-sm font-semibold mb-2 ${"text-gray-700"}`}>
  //             File Preview
  //           </p>
  //           <button
  //             className=" text-gray-600 hover:text-black"
  //             onClick={() => setFilePreview(null)}
  //           >
  //             <CloseModalIcon />
  //           </button>
  //         </div>
  //         <img
  //           src={`${mastersApi?.defaults?.baseURL}/${filePreview?.url}`}
  //           alt={filePreview?.name}
  //           className="w-full h-[70vh] object-contain rounded-md"
  //         />
  //         <p className={`text-xs mt-2 text-center ${"text-gray-600"}`}>
  //           {filePreview?.name}
  //         </p>
  //       </div>
  //     );
  //   } else if (filePreview?.type === "application/pdf") {
  //     return (
  //       <div className=" rounded-md p-3">
  //         <div className="flex justify-between">
  //           <p className="text-sm font-semibold mb-2 text-gray-700">
  //             PDF Preview
  //           </p>
  //           <button
  //             className=" text-gray-600 hover:text-black"
  //             onClick={() => setFilePreview(null)}
  //           >
  //             <CloseModalIcon />
  //           </button>
  //         </div>
  //         <iframe
  //           // src={`${baseUrl.replace(/\/$/, "")}/trainings/${filePreview?.url?.replace(/^\//, "")}#toolbar=0&navpanes=0&scrollbar=0`}
  //           src={`${mastersApi?.defaults?.baseURL}/${filePreview?.url}`}
  //           className="w-full h-[70vh] rounded-md"
  //           title={filePreview?.name}
  //         />

  //         <p className="text-xs text-gray-600 mt-2 text-center">
  //           {filePreview?.name}
  //         </p>
  //       </div>
  //     );
  //   } else {
  //     return (
  //       <div className="rounded-md p-3">
  //         <p className="text-sm font-semibold mb-2 text-gray-700">
  //           File Preview
  //         </p>
  //         <button
  //           className=" text-gray-600 hover:text-black"
  //           onClick={() => setFilePreview(null)}
  //         >
  //           <CloseModalIcon />
  //         </button>
  //         <div className="flex flex-col items-center justify-center h-64 bg-gray-50 rounded-md">
  //           {/* <FileIconSmall type={"button"} className="w-16 h-16 mb-4" /> */}
  //           <p className="text-sm font-medium text-gray-700">
  //             {filePreview.name}
  //           </p>
  //           <p className="text-xs text-gray-500 mt-1">
  //             {(filePreview.size / (1024 * 1024)).toFixed(2)} MB
  //           </p>
  //         </div>
  //       </div>
  //     );
  //   }
  // };
  const renderFilePreview = () => {
    if (!filePreview) return null;

    const closeBtn = (
      <button
        className={`transition text-gray-600 hover:text-black`}
        // onClick={() => setFilePreview(null)}
        onClick={() => {
          setFilePreview(null);
          if (pdfUrl) {
            URL.revokeObjectURL(pdfUrl);
            setPdfUrl(null);
          }
          if (imageUrl) {
            URL.revokeObjectURL(imageUrl);
            setImageUrl(null);
          }
        }}
      >
        <CloseModalIcon />
      </button>
    );

    if (filePreview?.type?.startsWith("image/")) {
      return (
        <div className="rounded-md p-1">
          <div className="flex justify-between">
            <p className={`text-sm font-semibold mb-2 text-gray-700`}>
              File Preview
            </p>
            {closeBtn}
          </div>
          {/* <img
            src={`${imageUrl}`}
            alt={filePreview.name}
            className="w-full h-[70vh] object-contain rounded-md"
          /> */}
          <img
            src={imageUrl}
            alt={filePreview.name}
            className="w-full h-[70vh] object-contain rounded-md"
          />
          <p className={`text-xs mt-2 text-center text-gray-600`}>
            {filePreview.name}
          </p>
        </div>
      );
    } else if (filePreview?.type === "application/pdf") {
      return (
        <div className="rounded-md p-1">
          <div className="flex justify-between">
            <p className={`text-sm font-semibold mb-2 text-gray-700`}>
              PDF Preview
            </p>
            {closeBtn}
          </div>
          {/* <iframe
            // src={`${baseUrl.replace(/\/$/, "")}/trainings/${filePreview?.path?.replace(/^\//, "")}#toolbar=0&navpanes=0&scrollbar=0`}
            src={pdfUrl} //             className="w-full h-[70vh] rounded-md"
            title={filePreview?.fileName}
          /> */}
          <iframe
            src={pdfUrl}
            className="w-full h-[70vh] rounded-md"
            title={filePreview?.fileName}
          />
          <p className={`text-xs mt-2 text-center text-gray-600`}>
            {filePreview?.fileName}
          </p>
        </div>
      );
    }
   
    else {
      return (
        <div className="rounded-md p-3">
          <p className={`text-sm font-semibold mb-2 text-gray-700`}>
            File Preview
          </p>
          <div
            className={`flex flex-col items-center justify-center h-64 rounded-md bg-gray-50`}
          >
            <p className={`text-sm font-medium text-gray-700`}>
              {filePreview.name}
            </p>
            <p className={`text-xs mt-1 text-gray-500`}>
              {(filePreview.size / (1024 * 1024)).toFixed(2)} MB
            </p>
          </div>
        </div>
      );
    }
  };
  const populateTable = (forPagination) => {
    let tempObj = { ...listingObject, page: !forPagination ? 0 : page };

    showSpinner(true);
    getAllTrainingMasterList(tempObj)
      .then((response) => response.data)
      .then((res) => {
        console.log("resssssssss", res);
        if (res.statusCode === 200 || res.statusCode === 204) {
          console.log("forPaginationforPagination", forPagination);
          if (forPagination) {
            setCoursesData((prevData) => [...prevData, ...res.result]);
          } else {
            setCoursesData(res.result);
          }
          setCount(res.count);
          showSpinner(false);
        }
      })
      .catch((error) => {
        console.log(error);
        showSpinner(false);
      });
  };

  useEffect(() => {
    if (selectedRow !== null && selectedRow?.Id) {
      setOpenBackdrop(true);
      getTrainingMasterInfo(selectedRow?.Id)
        .then((response) => response.data)
        .then((res) => {
          if (res.statusCode === 200) {
            const finalData = JSON.parse(res.result);
            console.log(finalData, "patientData");
            setSelectedRowDetail(finalData);
            setOpenBackdrop(false);
          }
        })
        .catch((error) => {
          errorAlert(error.message);
          setOpenBackdrop(false);
        });
    }
    //  else {
    //   setSelectedRowDetail(null);
    // }
  }, [selectedRow]);

  //   const handleDelete = () => {
  //     setOpenBackdrop(true);

  //     if (selectedRow !== null) {
  //       deleteKPIIndicator(selectedRow.Id)
  //         .then((response) => response.data)
  //         .then((res) => {
  //           console.log("aaaaaaaaaaa", res);
  //           successAlert(res.message);
  //           // setPage(0)
  //           populateTable();
  //           setOpenDeleteModal(false);
  //           setOpenBackdrop(false);
  //           setSelectedRow(null);
  //         })
  //         .catch((errors) => {
  //           console.log("err", errors);
  //           setOpenDeleteModal(false);
  //           setOpenBackdrop(false);
  //           setKPIIndicatorModalOpen(false);
  //           setSelectedRow(null);

  //         });
  //     }
  //   };
  //   useEffect(() => {
  //     populateTable();
  //   }, []);

  const getAssessmentQuestions = (trainingId, assessmentId) => {
    setOpenBackdrop(true);
    // if (selectedDataForAssessment !== null) {
    getAssessmentQuestionsList(trainingId, assessmentId)
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 200) {
          const finalData = JSON.parse(res.result);
          setAssessmentQuestionsData(finalData);
          setOpenPreAsstModal(true);
          setCount(res?.count);
          console.log(finalData, "assessmentQuestionsData");
        } else {
          errorAlert(res?.message);
        }
      })
      .catch((error) => {
        errorAlert(error?.message);
        console.log(error);
      })
      .finally(() => {
        setOpenBackdrop(false);
      });
    // }
  };
  useEffect(() => {
    populateTable();
  }, [listingObject?.searchId, listingObject?.searchString]);

  useEffect(() => {
    // if () {
    getDeptDropdown()
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 200) {
          setDepartmentDropdown(res.result);
        }
      })
      .catch((error) => errorAlert(error.message));
    // }
  }, []);
  return (
    <div className="px-2 my-1 w-full">
      {CommonHeading("Trainings")}
      <div className=" gap-2 w-full items-center mt-2">
        <div className="grid  grid-cols-4 gap-2">
          <SearchDropdown
            isDisabled={
              selectedRow?.editType == "View" ||
              selectedRow?.editType == "Schedule"
            }
            control={control}
            name="SearchableSelect"
            placeholder="Search by Training*"
            isSearchable={true}
            dataArray={trainingNameOptions}
            searchIcon={true}
            handleInputChange={(e) => {
              const tempCheckChar =
                e !== null ? UseCheckConsecutiveCharacters(e) : true;
              if (e !== "" && tempCheckChar) {
                getAllTrainingName(e)
                  .then((response) => {
                    setTrainingNameOptions(response.data.result);
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              } else {
                setTrainingNameOptions([]);
              }
            }}
            onChange={(e) => {
              if (e !== "") {
                setSearchString(e);
              } else {
                setSearchString(null);
              }
            }}
            isClearable={true}
            // error={errors?.training}
          />
          <DropdownField
            dataArray={departmentDropdown}
            name={"Department"}
            placeholder={"Department"}
            control={control}
            isClearable={true}
            isSearchable={true}
          />
          <div>
            <CommonButton
              className="bg-customBlue text-white"
              searchIcon={true}
              onClick={() =>
                setListingObject({
                  searchString: watch("SearchableSelect")?.label,
                  page: page,
                  size: rowsPerPage,
                  searchId: watch("SearchableSelect")
                    ? watch("SearchableSelect")?.id
                    : null,
                  menuId: null,
                  departmentId: watchDepartment ? watchDepartment?.id : null,
                })
              }
            />
          </div>
          <div className="flex justify-end">
            {userActions &&
              userActions.map((obj) => (
                <>
                  {!obj.isAction && obj.permission === "Create" ? (
                    <CommonButton
                      onClick={() => {
                        setTrainingModalOpen(true);
                        setSelectedRow(null);
                      }}
                      label="+ New"
                      className="modalButton bg-customBlue text-white"
                    />
                  ) : null}
                </>
              ))}
          </div>
        </div>

        <div className="w-full grid grid-cols-1 gap-2 mt-8">
          {coursesData?.length > 0 ? (
            coursesData.map((obj) => {
              return (
                <div className="my-1">
                  <Card
                  getTrainingDoc={getTrainingDoc}
                    getAssessmentQuestions={getAssessmentQuestions}
                    // setOpenPostModal={setOpenPostModal}
                    testData={testData}
                    open={openPreAsstModal}
                    setOpen={setOpenPreAsstModal}
                    course={obj}
                    renderFilePreview={renderFilePreview}
                    filePreview={filePreview}
                    setFilePreview={setFilePreview}
                    openPostAsstModal={openPostAsstModal}
                    setOpenPostAsstModal={setOpenPostAsstModal}
                    setSelectedRow={setSelectedRow}
                    selectedRow={selectedRow}
                    setTrainingModalOpen={setTrainingModalOpen}
                    trainingModalOpen={trainingModalOpen}
                    selectedDataForAssessment={selectedDataForAssessment}
                    setSelectedDataForAsessment={setSelectedDataForAsessment}
                  />
                </div>
              );
            })
          ) : (
            <>
              {!spinner && (
                <div className="flex justify-center">
                  <h3 className="flex justify-center mt-20 font-bold text-gray-600">
                    No Records Found...
                  </h3>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {spinner ? (
        <div className="grid justify-center items-center pt-12 w-full">
          {/* <CardSkeleton /> */}

          <LoadingSpinner />
        </div>
      ) : null}
      {openBackDrop && <CommonBackDrop openBackdrop={openBackDrop} />}
      <Modal
        open={Boolean(filePreview)}
        onClose={() => setFilePreview(null)}
        aria-labelledby="file-preview-modal"
      >
        <div className="fixed inset-0 flex items-center justify-center bg-black/60">
          <div className="bg-white w-[90%] md:w-[70%]  rounded-xl p-2 relative">
            {renderFilePreview()}
          </div>
        </div>
      </Modal>
      {openPreAsstModal && (
        <HandHygienePreAssessmentModal
          backendData={assessmentQuestionsData}
          open={openPreAsstModal}
          onClose={setOpenPreAsstModal}
          setTestData={setTestData}
          testData={testData}
        />
      )}
      {trainingModalOpen && (
        <TrainingMasterModal
          coursesData={coursesData}
          setCoursesData={setCoursesData}
          setTrainingModalOpen={setTrainingModalOpen}
          trainingModalOpen={trainingModalOpen}
          // setTrainingTableData={setTrainingTableData}
          // trainingTableData={trainingTableData}
          setSelectedRow={setSelectedRow}
          selectedRow={selectedRowDetail}
          setOpenBackdrop={setOpenBackdrop}
          openBackDrop={openBackDrop}
          populateTable={populateTable}
          setSelectedRowDetail={setSelectedRowDetail}
        />
      )}
    </div>
  );
};

export default TrainingsMaster;